var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf",
    transform: "translate(-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4322",
    "data-name": "Path 4322",
    d: "M98.5,0A2.507,2.507,0,0,0,96,2.5v35A2.507,2.507,0,0,0,98.5,40h25a2.507,2.507,0,0,0,2.5-2.5V10L116,0Z",
    transform: "translate(-59)",
    fill: "#e2e5e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4323",
    "data-name": "Path 4323",
    d: "M354.5,10H362L352,0V7.5A2.507,2.507,0,0,0,354.5,10Z",
    transform: "translate(-295)",
    fill: "#b0b7bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4324",
    "data-name": "Path 4324",
    d: "M391.5,135.5,384,128h7.5Z",
    transform: "translate(-324.5 -118)",
    fill: "#cad1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4325",
    "data-name": "Path 4325",
    d: "M62,253.75A1.254,1.254,0,0,1,60.75,255H33.25A1.254,1.254,0,0,1,32,253.75v-12.5A1.254,1.254,0,0,1,33.25,240h27.5A1.254,1.254,0,0,1,62,241.25Z",
    transform: "translate(0 -221.25)",
    fill: "#f15642"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9293",
    "data-name": "Group 9293",
    transform: "translate(37.449 22.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4326",
    "data-name": "Path 4326",
    d: "M101.744,295.01a.688.688,0,0,1,.679-.69h2.309a2.5,2.5,0,0,1,0,5h-1.669v1.32a.627.627,0,0,1-.64.689.673.673,0,0,1-.679-.689Zm1.319.569v2.49h1.669a1.246,1.246,0,0,0,0-2.49Z",
    transform: "translate(-101.744 -294.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4327",
    "data-name": "Path 4327",
    d: "M188.514,302.388a.626.626,0,0,1-.69-.619v-5.677a.68.68,0,0,1,.69-.62H190.8c4.567,0,4.467,6.916.09,6.916Zm.63-5.7v4.477H190.8c2.7,0,2.819-4.477,0-4.477Z",
    transform: "translate(-181.099 -295.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4328",
    "data-name": "Path 4328",
    d: "M288.444,296.757v1.589h2.549a.773.773,0,0,1,.72.709.7.7,0,0,1-.72.6h-2.549v2.1a.592.592,0,0,1-.6.619.635.635,0,0,1-.709-.619v-5.678a.632.632,0,0,1,.709-.62h3.509a.623.623,0,0,1,.7.62.691.691,0,0,1-.7.68h-2.91Z",
    transform: "translate(-272.652 -295.367)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4329",
    "data-name": "Path 4329",
    d: "M119.75,417.25H96v1.25h23.75a1.254,1.254,0,0,0,1.25-1.25V416A1.254,1.254,0,0,1,119.75,417.25Z",
    transform: "translate(-59 -383.5)",
    fill: "#cad1d8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.aabb4b29f850abb11cdf74cbb9c334a7.svg";
export { ForwardRef as ReactComponent };